import { toaster } from 'uikit/Toaster'
import { useMutation } from '@tanstack/react-query'
import { api } from 'api'

export const useTransferProcess = () => {
  return useMutation({
    mutationFn: (data) => api.referral.process(data),
    onError: (error) => {
      toaster.create({
        title: 'Не удалось отправить данные',
        description: error?.message,
        type: 'error',
      })
    }
  })
}
